"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteMetricId = void 0;
var SiteMetricId;
(function (SiteMetricId) {
    SiteMetricId["BounceRate"] = "bounceRate";
    SiteMetricId["CartAverage"] = "cartAverage";
    SiteMetricId["CartMedian"] = "cartMedian";
    SiteMetricId["ConversionCount"] = "conversionCount";
    SiteMetricId["ConversionRate"] = "conversionRate";
    SiteMetricId["NewVisits"] = "newVisits";
    SiteMetricId["RevenueSum"] = "revenueSum";
    SiteMetricId["SessionTimeAverage"] = "sessionTimeAverage";
    SiteMetricId["ViewAverage"] = "viewAverage";
    SiteMetricId["Views"] = "views";
    SiteMetricId["VisitCount"] = "visitCount";
    SiteMetricId["VisitRate"] = "visitRate";
})(SiteMetricId = exports.SiteMetricId || (exports.SiteMetricId = {}));
//# sourceMappingURL=site-metric.js.map